import { z } from 'zod';

export const ExportConfirmationModalSchema = z.object({
  examCourses: z
    .array(
      z.object({
        label: z.string(),
        value: z.string(),
      }),
    )
    .min(1, { message: 'กรุณาเลือกหลักสูตร' }),
});

export type ExportConfirmationModalFormInput = z.infer<typeof ExportConfirmationModalSchema>;
